import { normalizeAmount } from 'lib/utils/amount';

const PP_URLS = [
  'success',
  'fail',
  '404',
  'denied',
  'entercard',
  'secure',
  'paid',
  'failed',
  'rejected',
];

export const isNotPPRouteUrls = value => !PP_URLS.find(routeName => routeName === value);

const IFRAME_REGEX = /^<iframe.+iframe>$/;

export const isIframe = value => IFRAME_REGEX.test(String(value));

// eslint-disable-next-line no-useless-escape
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const isEmail = value => EMAIL_REGEX.test(String(value).toLowerCase());

// eslint-disable-next-line no-useless-escape
const PHONE_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

export const isPhone = value => {
  if (!value) {
    return true;
  }

  return PHONE_REGEX.test(String(value).toLowerCase());
};

// eslint-disable-next-line no-useless-escape
const URL_REGEX = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9а-я]+([\-\.]{1}[a-z0-9а-я]+)*\.[a-zа-я]{2,15}(:[0-9а-я]{1,15})?(\/.*)?$/i;

export const isUrl = value => URL_REGEX.test(String(value));

export const isEmailOrPhone = value => isEmail(value) || isPhone(value);
export const isUrlOrIframe = value => isUrl(value) || isIframe(value);

export const empty = value => value.length;

export const isMoreMinAmount = (minAmount, currency) => value => {
  if (!value) {
    return true;
  }

  let result = Number(value.replace(/\s/g, ''));
  result = result * 10 ** currency.significant_zeros;

  return result >= minAmount;
};

export const isLessMaxAmount = (maxAmount, commission, currency) => value => {
  if (!value) {
    return true;
  }

  const amount = normalizeAmount(value, currency);

  return amount + commission <= maxAmount;
};

